// extracted by mini-css-extract-plugin
export default {"container":"styles_container__m1i5Z","button":"styles_button__IA+oR","input":"styles_input__zfW5m","inputHolder":"styles_inputHolder__k6O3o"};